import React, { useState, useEffect } from 'react';
import cuteChessMascot from '../../assets/cute_chess_mascot.png';
import companionLeo from '../../assets/3d_icons/companion_leo.png';
import companionSparky from '../../assets/3d_icons/companion_sparky.png';
import companionMerlin from '../../assets/3d_icons/companion_merlin.png';
import companionRocky from '../../assets/3d_icons/companion_rocky.png';
import iconLibrary3d from '../../assets/3d_icons/icon_library.png';
import iconArena3d from '../../assets/3d_icons/icon_arena.png';
import iconMap3d from '../../assets/3d_icons/icon_map.png';
import { CartoonAvatar, XPBadge, ChessPieceIcon, StarIcon3D, StopwatchIcon3D, TargetIcon3D, TrophyIcon } from '../GamificationAssets';

const COMPANIONS = [
    { 
        name: 'King Leo', 
        emoji: '🦁', 
        avatar3d: companionLeo,
        role: 'The Brave Leader', 
        color: '#f59e0b', 
        desc: 'Rules the center of the board with courage!' 
    },
    { 
        name: 'Knight Sparky', 
        emoji: '🦄', 
        avatar3d: companionSparky,
        role: 'The Swift Jumper', 
        color: '#3b82f6', 
        desc: 'Leaps over obstacles and surprises enemies!' 
    },
    { 
        name: 'Bishop Merlin', 
        emoji: '🧙‍♂️', 
        avatar3d: companionMerlin,
        role: 'The Magic Slider', 
        color: '#7c3aed', 
        desc: 'Snipes targets from across the board with spells!' 
    },
    { 
        name: 'Rook Rocky', 
        emoji: '🐉', 
        avatar3d: companionRocky,
        role: 'The Castle Defender', 
        color: '#10b981', 
        desc: 'Unstoppable in straight lines, defends the fort!' 
    }
];

export default function StudentHome({ myBatches, allClasses, myHomeworks, myProfile, joinLiveClass, globalSettings, setActiveTab }) {
    const [selectedCompanion, setSelectedCompanion] = useState(() => {
        return localStorage.getItem('hayaa_companion') || 'King Leo';
    });

    const companion = COMPANIONS.find(c => c.name === selectedCompanion) || COMPANIONS[0];

    useEffect(() => {
        localStorage.setItem('hayaa_companion', selectedCompanion);
    }, [selectedCompanion]);

    const pendingHomeworks = (myHomeworks || []).filter(h => !(h.completedBy || []).includes(myProfile?.email));
    const activeLiveClass = (allClasses || []).find(c => c.status === 'LIVE' && (c.students || []).includes(myProfile?.email));
    const upcomingClasses = (allClasses || []).filter(c => c.status === 'UPCOMING' && (c.students || []).includes(myProfile?.email)).sort((a, b) => new Date(a.scheduledAt) - new Date(b.scheduledAt));
    const nextClass = upcomingClasses.length > 0 ? upcomingClasses[0] : null;

    const getCompanionMessage = () => {
        const count = pendingHomeworks.length;
        if (activeLiveClass) {
            switch(companion.name) {
                case 'King Leo': return `ROAR! A live class is active! To battle, my champion! Lead the charge! 🦁`;
                case 'Knight Sparky': return `Neighhh! The coach is waiting in the live classroom! Let's jump in, quick! 🦄`;
                case 'Bishop Merlin': return `The magic portal is open! The coach has summoned us to the live class! 🧙‍♂️`;
                case 'Rook Rocky': return `Live class is active! Get behind my stone shield, we are going in! 🐉`;
                default: return `Class is live! Let's go!`;
            }
        }
        if (count > 0) {
            switch(companion.name) {
                case 'King Leo': return `A true king never leaves his quests unfinished. We have ${count} homework task${count > 1 ? 's' : ''} to complete! 🦁`;
                case 'Knight Sparky': return `Let's hop, skip, and jump over to our homework quests! I'll help you find the best moves! 🦄`;
                case 'Bishop Merlin': return `I foresee great wisdom in completing your homework. Let's cast a spell and solve them! 🧙‍♂️`;
                case 'Rook Rocky': return `No enemy can breach our fortress! Let's defend our honor by doing homework! 🐉`;
                default: return `Let's work on our homework tasks!`;
            }
        }
        // Default clean state
        switch(companion.name) {
            case 'King Leo': return `All tasks are clear! A magnificent victory! Let's practice in the Battle Zone! 🦁`;
            case 'Knight Sparky': return `Woohoo! Zero homework left! High five! Let's challenge the AI bots to a friendly duel! 🦄`;
            case 'Bishop Merlin': return `My crystal ball shows no pending homework! Magical work! Let's explore Chess Worlds! 🧙‍♂️`;
            case 'Rook Rocky': return `Fortress is secure! All homework is completed! Let's roll into the Battle Zone! 🐉`;
            default: return `Welcome home, champion! Let's practice chess!`;
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '35px' }}>
            
            {/* 🚀 WELCOME HERO QUEST BANNER */}
            {/* 🚀 WELCOME HERO QUEST BANNER */}
            <div className="quest-banner">
                <style>{`
                    .quest-banner {
                        display: flex;
                        align-items: stretch;
                        justify-content: space-between;
                        min-height: 275px;
                        position: relative;
                        overflow: visible;
                        width: 100%;
                    }
                    .quest-banner-left {
                        padding: 35px 45px;
                        flex: 1 1 500px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        position: relative;
                        z-index: 5;
                    }
                    .quest-banner-right {
                        position: relative;
                        flex: 1 1 280px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        padding-right: 60px;
                        min-height: 200px;
                        z-index: 5;
                    }
                    .quest-banner-mascot {
                        height: 310px;
                        width: auto;
                        position: absolute;
                        left: -45px;
                        bottom: -12px;
                        filter: drop-shadow(0 15px 25px rgba(0, 0, 0, 0.4));
                        animation: float-cute 3s ease-in-out infinite;
                        pointer-events: none;
                        z-index: 10;
                    }
                    .quest-banner-arrow-btn {
                        width: 75px;
                        height: 50px;
                        border-radius: 25px;
                        background: #ffffff;
                        border: none;
                        cursor: pointer;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
                        z-index: 6;
                        outline: none;
                        transition: transform 0.2s ease;
                    }
                    .quest-banner-arrow-btn:hover {
                        transform: scale(1.08);
                    }
                    .quest-banner-arrow-btn:active {
                        transform: scale(0.95);
                    }
                    @media (max-width: 768px) {
                        .quest-banner {
                            flex-direction: column;
                            min-height: auto;
                            padding-bottom: 25px;
                        }
                        .quest-banner-left {
                            padding: 30px 25px;
                            flex: none;
                            align-items: center;
                            text-align: center;
                        }
                        .quest-banner-right {
                            flex: none;
                            justify-content: center;
                            padding-right: 0;
                            min-height: 180px;
                            margin-top: 10px;
                        }
                        .quest-banner-mascot {
                            position: relative;
                            left: auto;
                            bottom: 0;
                            height: 180px;
                            z-index: 10;
                        }
                        .quest-banner-arrow-btn {
                            display: none;
                        }
                    }
                `}</style>

                {/* 🌊 MILK SPLASH LAYERS AT THE BOTTOM WITH OVERFLOW HIDDEN CARD BACKDROP */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 50%, #42a5f5 100%)',
                    border: '3px solid rgba(255, 255, 255, 0.95)',
                    boxShadow: '0 15px 35px rgba(21, 101, 192, 0.3)',
                    borderRadius: '28px',
                    overflow: 'hidden',
                    zIndex: 1,
                    pointerEvents: 'none'
                }}>
                    <svg viewBox="0 0 1440 200" style={{ position: 'absolute', bottom: -1, left: 0, width: '100%', height: '60px', pointerEvents: 'none', zIndex: 1 }} preserveAspectRatio="none">
                        <path fill="#ffffff" d="M0,120 C180,180 320,60 480,120 C640,180 800,100 960,130 C1120,160 1280,110 1440,120 L1440,200 L0,200 Z" />
                        <path fill="rgba(255,255,255,0.25)" d="M0,90 C120,130 240,60 360,100 C480,140 600,80 720,110 C840,140 960,90 1080,110 C1200,130 1320,100 1440,110 L1440,200 L0,200 Z" />
                    </svg>
                </div>

                <div className="quest-banner-left">
                    <div style={{ color: 'rgba(255, 255, 255, 0.95)', fontSize: '15px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '6px' }}>
                        Hey {myProfile?.name?.split(' ')[0] || 'Chess Hero'}!
                    </div>
                    <h1 style={{ 
                        fontSize: '38px', 
                        fontWeight: '900', 
                        margin: '0 0 10px 0', 
                        color: '#ffffff', 
                        lineHeight: '1.2',
                        textShadow: '3px 4px 0px #0d47a1, 0 10px 20px rgba(0,0,0,0.25)',
                        letterSpacing: '-0.5px'
                    }}>
                        Ready for Today's Quest?
                    </h1>
                    <p style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '14px', margin: '0 0 25px 0', lineHeight: '1.6', fontWeight: '600', maxWidth: '500px' }}>
                        Your journey to grandmaster is full of fun! Join live classes, complete quests, and challenge our chess sidekicks to become the ultimate champion!
                    </p>

                    <div>
                        {activeLiveClass ? (
                            <button 
                                onClick={() => joinLiveClass(activeLiveClass)} 
                                className="kid-btn-bubble animate-pulse-ring animate-wiggle" 
                                style={{ 
                                    display: 'inline-flex', 
                                    alignItems: 'center', 
                                    gap: '12px', 
                                    padding: '14px 32px', 
                                    fontSize: '16px', 
                                    fontWeight: '900',
                                    background: '#ffffff',
                                    color: '#1565c0',
                                    border: 'none',
                                    borderRadius: '50px',
                                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
                                    cursor: 'pointer',
                                    outline: 'none',
                                    zIndex: 10
                                }}
                            >
                                🚀 LAUNCH MISSION NOW!
                                <span style={{ 
                                    display: 'inline-flex', 
                                    justifyContent: 'center', 
                                    alignItems: 'center', 
                                    width: '26px', 
                                    height: '26px', 
                                    background: '#1565c0', 
                                    color: '#ffffff', 
                                    borderRadius: '50%', 
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}>
                                    ➔
                                </span>
                            </button>
                        ) : (
                            <button 
                                onClick={() => {
                                    if (pendingHomeworks.length > 0) setActiveTab('homework');
                                    else if (nextClass) setActiveTab('classroom');
                                    else setActiveTab('chess-worlds');
                                }} 
                                className="kid-btn-bubble" 
                                style={{ 
                                    display: 'inline-flex', 
                                    alignItems: 'center', 
                                    gap: '12px', 
                                    padding: '14px 32px', 
                                    fontSize: '16px', 
                                    fontWeight: '900',
                                    background: '#ffffff',
                                    color: '#1565c0',
                                    border: 'none',
                                    borderRadius: '50px',
                                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
                                    cursor: 'pointer',
                                    outline: 'none',
                                    zIndex: 10
                                }}
                            >
                                {pendingHomeworks.length > 0 ? (
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
                                        Start Homework Quest
                                    </span>
                                ) : nextClass ? (
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                                        Check Upcoming Class
                                    </span>
                                ) : (
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                                        Resume Puzzle Adventure
                                    </span>
                                )}
                                <span style={{ 
                                    display: 'inline-flex', 
                                    justifyContent: 'center', 
                                    alignItems: 'center', 
                                    width: '26px', 
                                    height: '26px', 
                                    background: '#1565c0', 
                                    color: '#ffffff', 
                                    borderRadius: '50%', 
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}>
                                    ➔
                                </span>
                            </button>
                        )}
                    </div>
                </div>

                <div className="quest-banner-right">
                    {/* Cute Chess Mascot */}
                    <img 
                        src={cuteChessMascot} 
                        alt="Chess Mascot" 
                        className="quest-banner-mascot"
                    />

                    {/* White Pill Button with Arrow (exactly like the milk poster!) */}
                    <button 
                        onClick={() => {
                            if (activeLiveClass) joinLiveClass(activeLiveClass);
                            else if (pendingHomeworks.length > 0) setActiveTab('homework');
                            else if (nextClass) setActiveTab('classroom');
                            else setActiveTab('chess-worlds');
                        }}
                        className="quest-banner-arrow-btn"
                        title="Start Quest!"
                    >
                        <span style={{ fontSize: '24px', color: '#1565c0', fontWeight: 'bold' }}>➔</span>
                    </button>
                </div>
            </div>

            {/* ⏰ UPCOMING SESSION ALERT */}
            {!activeLiveClass && nextClass && (
                <div className="glass-panel" style={{ 
                    padding: '16px 28px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '20px', 
                    border: '3px solid rgba(255, 255, 255, 0.95)',
                    background: 'var(--bg-primary)',
                    boxShadow: 'var(--panel-shadow)',
                    borderRadius: '28px'
                }}>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        width: '48px', 
                        height: '48px', 
                        borderRadius: '14px', 
                        background: 'linear-gradient(135deg, #eff6ff, #dbeafe)', 
                        boxShadow: 'inset 2.5px 2.5px 5px rgba(255, 255, 255, 0.45), inset -2.5px -2.5px 5px rgba(0, 0, 0, 0.15), 0 5px 12px rgba(37,99,235,0.15)',
                        border: '2px solid rgba(255, 255, 255, 0.65)', 
                        animation: 'float-cute 3s ease-in-out infinite',
                        flexShrink: 0
                    }}>
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                    </div>
                    <div>
                        <div style={{ fontSize: '10px', color: '#2563eb', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Next Live Session</div>
                        <div style={{ color: 'var(--text-primary)', fontSize: '15px', fontWeight: '800' }}>
                            <span style={{ color: '#2563eb' }}>{nextClass.topic}</span> is scheduled for {new Date(nextClass.scheduledAt).toLocaleString()}
                        </div>
                    </div>
                </div>
            )}

            {/* 🦁 CHESS COMPANIONS & DIALOG SPACE */}
            <div className="glass-panel" style={{ 
                padding: '24px 30px', 
                border: '3px solid rgba(255, 255, 255, 0.95)',
                background: 'var(--bg-primary)',
                boxShadow: 'var(--panel-shadow)',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px',
                borderRadius: '28px'
            }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '900', color: '#1e3a8a' }}>
                        Your Chess Sidekick! 🤖
                    </h3>
                    <p style={{ margin: 0, fontSize: '13px', color: 'var(--text-secondary)', fontWeight: 'bold' }}>
                        Choose a sidekick to guide you on your adventures!
                    </p>
                </div>

                <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                    {COMPANIONS.map(comp => {
                        const isSelected = selectedCompanion === comp.name;
                        return (
                            <button
                                key={comp.name}
                                onClick={() => setSelectedCompanion(comp.name)}
                                style={{
                                    flex: '1 1 140px',
                                    padding: '10px 14px',
                                    background: isSelected 
                                        ? `linear-gradient(135deg, ${comp.color}08, ${comp.color}15)` 
                                        : 'var(--bg-primary)',
                                    border: isSelected ? `2.5px solid ${comp.color}` : '2.5px solid rgba(255,255,255,0.95)',
                                    borderRadius: '20px',
                                    cursor: 'pointer',
                                    boxShadow: isSelected 
                                        ? 'var(--neu-shadow-inset)' 
                                        : 'var(--neu-shadow)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    justifyContent: 'flex-start',
                                    outline: 'none',
                                    transition: 'all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
                                    transform: isSelected ? 'scale(0.96)' : 'scale(1)'
                                }}
                                onMouseEnter={e => {
                                    if (!isSelected) {
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.boxShadow = 'var(--neu-shadow-hover)';
                                    }
                                }}
                                onMouseLeave={e => {
                                    if (!isSelected) {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'var(--neu-shadow)';
                                    }
                                }}
                            >
                                <div style={{
                                    width: '38px',
                                    height: '38px',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: isSelected 
                                        ? `linear-gradient(135deg, ${comp.color}25, ${comp.color}45)`
                                        : 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
                                    boxShadow: isSelected
                                        ? 'inset 2px 2px 4px rgba(255, 255, 255, 0.45), inset -2px -2px 4px rgba(0, 0, 0, 0.18)'
                                        : 'inset 2px 2px 4px rgba(255, 255, 255, 0.7), inset -2px -2px 4px rgba(0, 0, 0, 0.08), 0 3px 6px rgba(163, 177, 198, 0.12)',
                                    border: isSelected ? `1.5px solid ${comp.color}50` : '1.5px solid rgba(255, 255, 255, 0.65)',
                                    flexShrink: 0,
                                    overflow: 'hidden'
                                }}>
                                    <img src={comp.avatar3d} alt={comp.name} style={{ width: '85%', height: '85%', objectFit: 'contain' }} />
                                </div>
                                <div style={{ textAlign: 'left', minWidth: 0 }}>
                                    <div style={{ fontWeight: '900', fontSize: '13px', color: 'var(--text-primary)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{comp.name}</div>
                                    <div style={{ fontSize: '9px', color: 'var(--text-secondary)', fontWeight: 'bold' }}>{comp.role}</div>
                                </div>
                            </button>
                        );
                    })}
                </div>

                {/* Speech Bubble Desk */}
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '20px', 
                    background: 'var(--bg-primary)', 
                    borderRadius: '24px', 
                    padding: '20px 25px', 
                    boxShadow: 'var(--neu-shadow-inset)',
                    border: '1px solid rgba(255, 255, 255, 0.4)',
                    flexWrap: 'wrap'
                }}>
                    <div className="animate-float-cute" style={{ 
                        width: '64px', 
                        height: '64px', 
                        borderRadius: '16px', 
                        background: `linear-gradient(135deg, ${companion.color}15, ${companion.color}35)`, 
                        boxShadow: 'inset 3px 3px 6px rgba(255, 255, 255, 0.5), inset -3px -3px 6px rgba(0, 0, 0, 0.12), 0 10px 20px rgba(0, 0, 0, 0.08)', 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        border: `3.5px solid ${companion.color}60`,
                        flexShrink: 0,
                        overflow: 'hidden'
                    }}>
                        <img src={companion.avatar3d} alt={companion.name} style={{ width: '85%', height: '85%', objectFit: 'contain' }} />
                    </div>

                    <div style={{ 
                        flex: 1, 
                        minWidth: '200px', 
                        position: 'relative', 
                        background: '#fff', 
                        padding: '16px 20px', 
                        borderRadius: '20px', 
                        boxShadow: '0 4px 15px rgba(163, 177, 198, 0.2)',
                        border: `2px solid ${companion.color}`
                    }}>
                        {/* Speech Bubble Arrow */}
                        <div style={{
                            position: 'absolute',
                            left: '-10px',
                            top: '22px',
                            width: '0',
                            height: '0',
                            borderTop: '10px solid transparent',
                            borderBottom: '10px solid transparent',
                            borderRight: `10px solid ${companion.color}`,
                            display: 'block'
                        }}></div>

                        <div style={{ fontWeight: '800', fontSize: '14px', color: '#1e3a8a', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            {companion.name} says:
                        </div>
                        <div style={{ color: 'var(--text-primary)', fontSize: '15px', fontWeight: '700', lineHeight: '1.4' }}>
                            "{getCompanionMessage()}"
                        </div>
                    </div>
                </div>

            </div>

            {/* 🧸 3 GAMIFIED MODULE CARDS */}
            <div style={{ display: 'flex', gap: '25px', flexWrap: 'wrap' }}>
                
                {/* 1. ADVENTURE BOOK (HOMEWORK QUEST) */}
                <div 
                    className="neu-panel-inner kid-card"
                    onClick={() => setActiveTab('homework')}
                    style={{ 
                        flex: '1 1 300px', 
                        padding: '30px', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        gap: '20px', 
                        cursor: 'pointer', 
                        position: 'relative', 
                        border: '3px solid rgba(255, 255, 255, 0.95)',
                        background: 'var(--bg-primary)',
                        boxShadow: 'var(--panel-shadow)'
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            width: '60px', 
                            height: '60px', 
                            borderRadius: '16px', 
                            background: 'linear-gradient(135deg, #eff6ff, #dbeafe)', 
                            boxShadow: 'inset 2.5px 2.5px 5px rgba(255, 255, 255, 0.45), inset -2.5px -2.5px 5px rgba(0, 0, 0, 0.15), 0 6px 14px rgba(37, 99, 235, 0.15)', 
                            border: '1.5px solid rgba(255, 255, 255, 0.65)',
                            flexShrink: 0,
                            overflow: 'hidden'
                        }}>
                            <img src={iconLibrary3d} alt="Book" style={{ width: '80%', height: '80%', objectFit: 'contain', animation: 'float-cute 4s ease-in-out infinite' }} />
                        </div>
                        {pendingHomeworks.length > 0 ? (
                            <span style={{ 
                                background: 'linear-gradient(135deg, #ef4444, #dc2626)', 
                                color: '#fff', 
                                padding: '5px 12px', 
                                borderRadius: '15px', 
                                fontSize: '11px', 
                                fontWeight: '900',
                                boxShadow: '0 4px 10px rgba(239, 68, 68, 0.3)',
                                border: '1.5px solid #fff'
                            }}>
                                {pendingHomeworks.length} QUESTS
                            </span>
                        ) : (
                            <span style={{ 
                                background: 'linear-gradient(135deg, #10b981, #059669)', 
                                color: '#fff', 
                                padding: '5px 12px', 
                                borderRadius: '15px', 
                                fontSize: '11px', 
                                fontWeight: '900',
                                boxShadow: '0 4px 10px rgba(16, 185, 129, 0.3)',
                                border: '1.5px solid #fff'
                            }}>
                                ALL CLEAR!
                            </span>
                        )}
                    </div>

                    <div>
                        <h3 style={{ margin: '0 0 6px 0', fontSize: '20px', color: '#1e3a8a', fontWeight: '900' }}>Adventure Book</h3>
                        <p style={{ margin: '0 0 15px 0', fontSize: '13px', color: 'var(--text-secondary)', fontWeight: 'bold', lineHeight: '1.4' }}>
                            Open your notebook to find tactical quests assigned by your coach!
                        </p>

                        {/* Mini Checklist inside */}
                        <div style={{ 
                            background: 'var(--bg-primary)', 
                            borderRadius: '16px', 
                            padding: '12px 15px', 
                            boxShadow: 'var(--neu-shadow-inset)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px'
                        }}>
                            {pendingHomeworks.length > 0 ? (
                                pendingHomeworks.slice(0, 2).map((hw, idx) => (
                                    <div key={hw.id || idx} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: 'var(--text-primary)', fontWeight: '700' }}>
                                        <span style={{ color: '#ef4444', fontSize: '14px' }}>⬜</span>
                                        <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '200px' }}>
                                            {hw.title || `Homework Quest #${idx + 1}`}
                                        </span>
                                    </div>
                                ))
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: '#10b981', fontWeight: '700' }}>
                                    <span>🎉</span>
                                    <span>No pending quests. You are awesome!</span>
                                </div>
                            )}
                            {pendingHomeworks.length > 2 && (
                                <div style={{ fontSize: '10px', color: '#2563eb', fontWeight: '900', textAlign: 'right', marginTop: '2px' }}>
                                    + {pendingHomeworks.length - 2} more quests!
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* 2. BATTLE ZONE (PLAY WITH AI) */}
                <div 
                    className="neu-panel-inner kid-card"
                    onClick={() => setActiveTab('arena')}
                    style={{ 
                        flex: '1 1 300px', 
                        padding: '30px', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        gap: '20px', 
                        cursor: 'pointer', 
                        position: 'relative', 
                        border: '3px solid rgba(255, 255, 255, 0.95)',
                        background: 'var(--bg-primary)',
                        boxShadow: 'var(--panel-shadow)'
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            width: '60px', 
                            height: '60px', 
                            borderRadius: '16px', 
                            background: 'linear-gradient(135deg, #f5f3ff, #ede9fe)', 
                            boxShadow: 'inset 2.5px 2.5px 5px rgba(255, 255, 255, 0.45), inset -2.5px -2.5px 5px rgba(0, 0, 0, 0.15), 0 6px 14px rgba(124, 58, 237, 0.15)', 
                            border: '1.5px solid rgba(255, 255, 255, 0.65)',
                            flexShrink: 0,
                            overflow: 'hidden'
                        }}>
                            <img src={iconArena3d} alt="Arena" style={{ width: '80%', height: '80%', objectFit: 'contain', animation: 'float-cute 4.5s ease-in-out infinite' }} />
                        </div>
                        <span style={{ 
                            background: 'linear-gradient(135deg, #7c3aed, #6d28d9)', 
                            color: '#fff', 
                            padding: '5px 12px', 
                            borderRadius: '15px', 
                            fontSize: '11px', 
                            fontWeight: '900',
                            boxShadow: '0 4px 10px rgba(124, 58, 237, 0.3)',
                            border: '1.5px solid #fff'
                        }}>
                            AI BOT ARENA
                        </span>
                    </div>

                    <div>
                        <h3 style={{ margin: '0 0 6px 0', fontSize: '20px', color: '#1e3a8a', fontWeight: '900' }}>Battle Zone</h3>
                        <p style={{ margin: '0 0 15px 0', fontSize: '13px', color: 'var(--text-secondary)', fontWeight: 'bold', lineHeight: '1.4' }}>
                            Challenge Sparky, Leo, or Merlin to a practice match! Level up your skills!
                        </p>

                        <div style={{ 
                            background: 'var(--bg-primary)', 
                            borderRadius: '16px', 
                            padding: '12px 15px', 
                            boxShadow: 'var(--neu-shadow-inset)',
                            display: 'flex',
                            justifyContent: 'space-around',
                            userSelect: 'none'
                        }}>
                            <div className="animate-float-cute" style={{ animationDelay: '0s', width: '38px', height: '38px', borderRadius: '10px', background: 'linear-gradient(135deg, #fffbeb, #fef3c7)', boxShadow: 'inset 2px 2px 4px rgba(255, 255, 255, 0.45), inset -2px -2px 4px rgba(0, 0, 0, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(255, 255, 255, 0.5)', overflow: 'hidden' }}><img src={companionLeo} alt="Leo" style={{ width: '85%', height: '85%', objectFit: 'contain' }} /></div>
                            <div className="animate-float-cute" style={{ animationDelay: '0.4s', width: '38px', height: '38px', borderRadius: '10px', background: 'linear-gradient(135deg, #eff6ff, #dbeafe)', boxShadow: 'inset 2px 2px 4px rgba(255, 255, 255, 0.45), inset -2px -2px 4px rgba(0, 0, 0, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(255, 255, 255, 0.5)', overflow: 'hidden' }}><img src={companionSparky} alt="Sparky" style={{ width: '85%', height: '85%', objectFit: 'contain' }} /></div>
                            <div className="animate-float-cute" style={{ animationDelay: '0.8s', width: '38px', height: '38px', borderRadius: '10px', background: 'linear-gradient(135deg, #f5f3ff, #ede9fe)', boxShadow: 'inset 2px 2px 4px rgba(255, 255, 255, 0.45), inset -2px -2px 4px rgba(0, 0, 0, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(255, 255, 255, 0.5)', overflow: 'hidden' }}><img src={companionMerlin} alt="Merlin" style={{ width: '85%', height: '85%', objectFit: 'contain' }} /></div>
                            <div className="animate-float-cute" style={{ animationDelay: '1.2s', width: '38px', height: '38px', borderRadius: '10px', background: 'linear-gradient(135deg, #ecfdf5, #d1fae5)', boxShadow: 'inset 2px 2px 4px rgba(255, 255, 255, 0.45), inset -2px -2px 4px rgba(0, 0, 0, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(255, 255, 255, 0.5)', overflow: 'hidden' }}><img src={companionRocky} alt="Rocky" style={{ width: '85%', height: '85%', objectFit: 'contain' }} /></div>
                        </div>
                    </div>
                </div>

                {/* 3. TREASURE MAP (CHESS WORLDS PUZZLES) */}
                <div 
                    className="neu-panel-inner kid-card"
                    onClick={() => setActiveTab('chess-worlds')}
                    style={{ 
                        flex: '1 1 300px', 
                        padding: '30px', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        gap: '20px', 
                        cursor: 'pointer', 
                        position: 'relative', 
                        border: '3px solid rgba(255, 255, 255, 0.95)',
                        background: 'var(--bg-primary)',
                        boxShadow: 'var(--panel-shadow)'
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', 
                            width: '60px', 
                            height: '60px', 
                            borderRadius: '16px', 
                            background: 'linear-gradient(135deg, #ecfdf5, #d1fae5)', 
                            boxShadow: 'inset 2.5px 2.5px 5px rgba(255, 255, 255, 0.45), inset -2.5px -2.5px 5px rgba(0, 0, 0, 0.15), 0 6px 14px rgba(16, 185, 129, 0.15)', 
                            border: '1.5px solid rgba(255, 255, 255, 0.65)',
                            flexShrink: 0,
                            overflow: 'hidden'
                        }}>
                            <img src={iconMap3d} alt="Map" style={{ width: '80%', height: '80%', objectFit: 'contain', animation: 'float-cute 4s ease-in-out infinite' }} />
                        </div>
                        <span style={{ 
                            background: 'linear-gradient(135deg, #10b981, #059669)', 
                            color: '#fff', 
                            padding: '5px 12px', 
                            borderRadius: '15px', 
                            fontSize: '11px', 
                            fontWeight: '900',
                            boxShadow: '0 4px 10px rgba(16, 185, 129, 0.3)',
                            border: '1.5px solid #fff'
                        }}>
                            PUZZLES
                        </span>
                    </div>

                    <div>
                        <h3 style={{ margin: '0 0 6px 0', fontSize: '20px', color: '#1e3a8a', fontWeight: '900' }}>Treasure Map</h3>
                        <p style={{ margin: '0 0 15px 0', fontSize: '13px', color: 'var(--text-secondary)', fontWeight: 'bold', lineHeight: '1.4' }}>
                            Travel across magical worlds, solve chess puzzles, and loot hidden chests!
                        </p>

                        <div style={{ 
                            background: 'var(--bg-primary)', 
                            borderRadius: '16px', 
                            padding: '12px 15px', 
                            boxShadow: 'var(--neu-shadow-inset)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '8px',
                            fontWeight: 'bold',
                            fontSize: '11px',
                            color: 'var(--text-secondary)'
                        }}>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" /><line x1="9" y1="3" x2="9" y2="18" /><line x1="15" y1="6" x2="15" y2="21" /></svg>
                            <span>➔</span>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 22h16" /><path d="M4 20v-3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3" /><path d="M6 14V4h12v10" /><path d="M6 4V2h3v2h6V2h3v2" /></svg>
                            <span>➔</span>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 20v-9a2 2 0 0 0-2-2h-3V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2H5a2 2 0 0 0-2 2v11" /><path d="M12 21v-4a2 2 0 0 0-4 0v4" /><path d="M4 21h16" /></svg>
                            <span>➔</span>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#eab308" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'float-cute 2s ease-in-out infinite', display: 'inline-block' }}><polygon points="6 3 18 3 22 9 12 22 2 9 6 3" fill="#eab308" /></svg>
                        </div>
                    </div>
                </div>

            </div>

            {/* 🏆 GAMIFIED QUICK STATS ROW */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                gap: '16px',
            }}>
                <style>{`
                    @keyframes stat-pop {
                        0%  { transform: scale(0.88); opacity: 0; }
                        60% { transform: scale(1.05); }
                        100%{ transform: scale(1);    opacity: 1; }
                    }
                    .stat-card {
                        display: flex; flex-direction: column; align-items: center;
                        gap: 8px; padding: 22px 12px;
                        border-radius: 24px;
                        background: var(--bg-primary);
                        border: 2px solid rgba(255,255,255,0.8);
                        box-shadow: 8px 8px 18px rgba(163,177,198,0.25), -8px -8px 18px rgba(255,255,255,0.65);
                        transition: transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s;
                        animation: stat-pop 0.5s ease both;
                        cursor: default;
                    }
                    .stat-card:hover {
                        transform: translateY(-6px) scale(1.03);
                        box-shadow: 12px 12px 28px rgba(163,177,198,0.35), -12px -12px 28px rgba(255,255,255,0.9);
                    }
                    .stat-icon-ring {
                        width: 56px; height: 56px; border-radius: 50%;
                        display: flex; align-items: center; justify-content: center;
                        box-shadow: inset 3px 3px 7px rgba(255,255,255,0.55), inset -3px -3px 7px rgba(163,177,198,0.25), 0 6px 18px rgba(0,0,0,0.07);
                    }
                `}</style>

                {/* Total XP */}
                <div className="stat-card" style={{ animationDelay: '0s' }}>
                    <div className="stat-icon-ring" style={{ background: 'transparent', boxShadow: 'none' }}>
                        <TrophyIcon size={50} color="#f59e0b" />
                    </div>
                    <div style={{ fontWeight: 900, fontSize: '22px', color: 'var(--text-primary)', lineHeight: 1 }}>
                        {(myProfile?.totalXp || 0).toLocaleString()}
                    </div>
                    <div style={{ fontSize: '11px', fontWeight: 700, color: '#f59e0b', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Total XP</div>
                    <XPBadge xp={myProfile?.totalXp || 0} size="sm" color="gold" />
                </div>

                {/* Level */}
                <div className="stat-card" style={{ animationDelay: '0.07s' }}>
                    <div className="stat-icon-ring" style={{ background: 'transparent', boxShadow: 'none' }}>
                        <StarIcon3D size={50} />
                    </div>
                    <div style={{ fontWeight: 900, fontSize: '22px', color: 'var(--text-primary)', lineHeight: 1 }}>
                        {myProfile?.level || 1}
                    </div>
                    <div style={{ fontSize: '11px', fontWeight: 700, color: '#7c3aed', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Rank Level</div>
                    <span style={{ fontSize: '11px', background: 'linear-gradient(135deg, #7c3aed, #4c1d95)', color: '#fff', padding: '2px 10px', borderRadius: '20px', fontWeight: 800 }}>
                        {['', 'Pawn', 'Knight', 'Bishop', 'Rook', 'Queen', 'King'][myProfile?.level || 1] || `Lv.${myProfile?.level}`}
                    </span>
                </div>

                {/* Homework Done */}
                <div className="stat-card" style={{ animationDelay: '0.14s' }}>
                    <div className="stat-icon-ring" style={{ background: 'transparent', boxShadow: 'none' }}>
                        <TargetIcon3D size={50} />
                    </div>
                    <div style={{ fontWeight: 900, fontSize: '22px', color: 'var(--text-primary)', lineHeight: 1 }}>
                        {(myHomeworks || []).filter(h => (h.completedBy || []).includes(myProfile?.email)).length}
                    </div>
                    <div style={{ fontSize: '11px', fontWeight: 700, color: '#10b981', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Quests Done</div>
                    <span style={{ fontSize: '11px', background: 'linear-gradient(135deg,#10b981,#059669)', color: '#fff', padding: '2px 10px', borderRadius: '20px', fontWeight: 800 }}>Completed</span>
                </div>

                {/* Pending Homework */}
                <div className="stat-card" style={{ animationDelay: '0.21s' }}>
                    <div className="stat-icon-ring" style={{ background: 'transparent', boxShadow: 'none' }}>
                        <StopwatchIcon3D size={50} />
                    </div>
                    <div style={{ fontWeight: 900, fontSize: '22px', color: 'var(--text-primary)', lineHeight: 1 }}>
                        {(myHomeworks || []).filter(h => !(h.completedBy || []).includes(myProfile?.email)).length}
                    </div>
                    <div style={{ fontSize: '11px', fontWeight: 700, color: '#ec4899', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Active Quests</div>
                    <span style={{ fontSize: '11px', background: (myHomeworks || []).filter(h => !(h.completedBy || []).includes(myProfile?.email)).length > 0 ? 'linear-gradient(135deg,#ef4444,#dc2626)' : 'linear-gradient(135deg,#10b981,#059669)', color: '#fff', padding: '2px 10px', borderRadius: '20px', fontWeight: 800 }}>
                        {(myHomeworks || []).filter(h => !(h.completedBy || []).includes(myProfile?.email)).length > 0 ? '⚠ Pending' : '✅ All Clear!'}
                    </span>
                </div>

                {/* Classes Joined */}
                <div className="stat-card" style={{ animationDelay: '0.28s' }}>
                    <div className="stat-icon-ring" style={{ background: 'linear-gradient(135deg, #dbeafe, #bfdbfe)' }}>
                        <ChessPieceIcon piece="rook" size={32} color="#2563eb" />
                    </div>
                    <div style={{ fontWeight: 900, fontSize: '22px', color: 'var(--text-primary)', lineHeight: 1 }}>
                        {(myBatches || []).length}
                    </div>
                    <div style={{ fontSize: '11px', fontWeight: 700, color: '#2563eb', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Batches</div>
                    <span style={{ fontSize: '11px', background: 'linear-gradient(135deg,#2563eb,#1e3a8a)', color: '#fff', padding: '2px 10px', borderRadius: '20px', fontWeight: 800 }}>Enrolled</span>
                </div>
            </div>

        </div>
    );
}
